
import { Button } from "@/components/ui/button";
import SpotImage from "./SpotImage";
import SpotAvailability from "./SpotAvailability";

interface SpotDetailsProps {
  spot: {
    id: string;
    owner_id: string;
    owner_name: string;
    address: string;
    vehicle_type: string;
    security_type: string;
    price_per_hour: number;
    parking_lot_count: number;
    images: string[];
    is_available: boolean;
  };
  isOwner: boolean;
  isUpdating: boolean;
  onAvailabilityChange: (value: string) => void;
  onEditClick: (e: React.MouseEvent) => void;
  onBookClick: (e: React.MouseEvent) => void;
  setDialogOpen: (open: boolean) => void;
}

const SpotDetails = ({ 
  spot, 
  isOwner, 
  isUpdating, 
  onAvailabilityChange, 
  onEditClick,
  onBookClick,
  setDialogOpen
}: SpotDetailsProps) => {
  return (
    <div className="space-y-2">
      {!isOwner && spot.is_available && (
        <Button 
          className="w-full mb-4 bg-primary hover:bg-primary/90" 
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setDialogOpen(true);
          }}
        >
          Book Parking Space
        </Button>
      )}
      
      <p>
        <span className="font-semibold">Owner:</span> {spot.owner_name}
      </p>
      <p>
        <span className="font-semibold">Vehicle Type:</span> {spot.vehicle_type}
      </p>
      <p>
        <span className="font-semibold">Security:</span> {spot.security_type}
      </p>
      <p>
        <span className="font-semibold">Price:</span> ₹{spot.price_per_hour}/hour
      </p>
      <p>
        <span className="font-semibold">Available Lots:</span> {spot.parking_lot_count}
      </p>
      <p>
        <span className="font-semibold">Address:</span> {spot.address}
      </p>
      
      <SpotImage images={spot.images} />
      
      {isOwner && (
        <>
          <SpotAvailability
            isAvailable={spot.is_available}
            isUpdating={isUpdating}
            onAvailabilityChange={onAvailabilityChange}
          />
          <Button 
            variant="outline" 
            className="w-full mt-2"
            onClick={onEditClick}
          >
            Edit Details
          </Button>
        </>
      )}
    </div>
  );
};

export default SpotDetails;
